import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const GenerativeAIPage: React.FC = () => {
  return <ServicePageTemplate slug="generative-ai" />;
};

export default GenerativeAIPage;
